<template>
<Toast/>
  <div class="row">
    <div class="col titre">
      <h2>Pays</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-4 lbl">
      <label>Pays :</label>
    </div>
    <div class="col-4">
      <InputText type="string" v-model="texte" />
    </div>
  </div>
  <div class="row solid-line"/>
  <div class="row">
    <div class="col">
      <div v-if="enregistrementEnCours == false">
        <Button @click="ajouter">Sauvegarder</Button>
      </div>
      <div v-else>
        <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
      </div>
    </div>
    <div class="col">
      <Button @click="fermer">Fermer</Button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Ajout Pays");
  },
  data() {
    return {
      texte: null,
      code: 'Pays',
      enregistrementEnCours: false
    }
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  methods: {
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    ajouter(){
        this.enregistrementEnCours = true;

        let tableValeurLocal = {};
        tableValeurLocal.tableValeurVO = {};
        tableValeurLocal.tableValeurVO.code = this.code;
        tableValeurLocal.tableValeurVO.description = this.texte;
        tableValeurLocal.tableValeurVO.actif = true;
        tableValeurLocal.libelleVO = {};
        tableValeurLocal.libelleVO.texte = this.texte;

        this.$store.dispatch('pilotage/ajouterTableValeurAction', {
            ascendantCle: 0,
            tableValeur: tableValeurLocal
        }).then(() => {
          this.enregistrementEnCours = false;
          this.$toast.add({
              severity: 'success',
              summary: 'Sauvegarder',
              detail: 'Le pays a été ajouté',
              life: 6000
          })
        }).catch(err => {
          this.$toast.add({
              severity: 'error',
              summary: 'Sauvegarder',
              detail: `Erreur lors de l'enregistrement du type: ${err}`,
              life: 6000
          })
          this.enregistrementEnCours = false;
        })
    },
  }
    
}
</script>
